import { mapGetters } from "vuex";

export default {
  beforeMount() {
    this.$store.commit('pageLoad')
  },
  mounted () {
    this.fetchItem().then(() => {
      this.$store.commit('isPageLoad')
    })
  },
  methods: {
    fetchItem (ssr = false) {
      return this.$store.dispatch('fetchCurrentPage', 
        {page: 'about', ssr: ssr, host: this.getHost}
      )
    },
    edit(code, block) {
      if(this.getUser) {
        this.$store.commit('setEditor',
          {code: code, block: block, page: 'about' }
        )
      }
    }
  },
  computed: {
    ...mapGetters(["getCurrentPage", "getUser", "getHost"])
  }
};


// WEBPACK FOOTER //
// ./src/pages/About/about.js